import React from "react";
import PropTypes from "prop-types";
import { getHoursSuffix } from "lib/datetime";
import { noop } from "lodash-es";
import cn from "classnames";

const GroupPreview = ({ name, players, stackSize, modificators, onClick }) => {
    return (
        <div
            className={cn("group-preview", modificators.container)}
            onClick={onClick}
        >
            <div className="group-preview__name">{name}</div>
            <div className="group-preview__info">
                <div className="group-preview-members">
                    <div className="group-preview-members__list">
                        <div className="players-stack">
                            {players.slice(0, stackSize).map((player, key) => (
                                <div
                                    className="players-stack__item players-stack__item_small"
                                    key={key}
                                >
                                    {player &&
                                        player.avatar &&
                                        player?.avatar?.url?.length > 0 && (
                                            <img
                                                src={player.avatar.url}
                                                alt={`аватар игрока ${player.full_name}`}
                                            />
                                        )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="group-preview-members__count">
                        {players.length} игрок{getHoursSuffix(players.length)}
                    </div>
                </div>
            </div>
        </div>
    );
};

GroupPreview.defaultProps = {
    players: [],
    stackSize: 4,
    modificators: {},
    onClick: noop,
};

GroupPreview.propTypes = {
    modificators: PropTypes.shape({
        container: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
    name: PropTypes.string,
    players: PropTypes.arrayOf(PropTypes.shape({})),
    stackSize: PropTypes.number,
    onClick: PropTypes.func,
};

export default GroupPreview;
